/**
 * @generated SignedSource<<97417faeed5c465aaae147c5682892fc>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type MediaEditorDeleteMutation$variables = {
  connections: ReadonlyArray<string>;
  id: string;
};
export type MediaEditorDeleteMutation$data = {
  readonly deleteNode: string | null;
};
export type MediaEditorDeleteMutation = {
  response: MediaEditorDeleteMutation$data;
  variables: MediaEditorDeleteMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "connections"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v2 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v3 = {
  "alias": null,
  "args": (v2/*: any*/),
  "kind": "ScalarField",
  "name": "deleteNode",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "MediaEditorDeleteMutation",
    "selections": [
      (v3/*: any*/)
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "MediaEditorDeleteMutation",
    "selections": [
      (v3/*: any*/),
      {
        "alias": null,
        "args": (v2/*: any*/),
        "filters": null,
        "handle": "deleteEdge",
        "key": "",
        "kind": "ScalarHandle",
        "name": "deleteNode",
        "handleArgs": [
          {
            "kind": "Variable",
            "name": "connections",
            "variableName": "connections"
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "c85360cd3f5dd485d9bc83ee1df727d4",
    "id": null,
    "metadata": {},
    "name": "MediaEditorDeleteMutation",
    "operationKind": "mutation",
    "text": "mutation MediaEditorDeleteMutation(\n  $id: ID!\n) {\n  deleteNode(id: $id)\n}\n"
  }
};
})();

(node as any).hash = "87c7a089a434e67ea003bf36a4071f86";

export default node;
